export const redirectToHelpCenter = () => {
    window.location.replace('/help-center');
};
